<template>
  <!-- レポート作成 -->
  <div id="KenshinDateExtract">
    <div id="container">
      <div class="labelTitle lable">判定医 月次レポート</div>
      <!--検索条件 -->
      <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>年月</th><td style="width:200px;"><input type="month" v-model="searchCondition.yearMonth" /></td>
              <th>判定医療機関</th>
              <td style="width:400px;">
                <input type="text" style="width:270px;" disabled="disabled" v-model="searchCondition.doctorName"/>
                <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">判定医選択</b-button>
              </td>
            </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>

      </div>
      <!-- 検索結果 -->
      <div v-if="data.length > 0">
        <div id="item-contens">
            <div class="card-content margin-top">
                <table>
                    <tr><th>期間</th><td>{{data.yearMonth}}</td></tr>
                    <tr><th>判定医療機関</th><td>{{data.doctorName}}</td></tr>
                </table>
            </div>
        </div>  
        <div class="button-area">
          <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('kenshinDateExtractTable')">クリップボードにコピー</b-button>
        </div>
        <div class="table-wrapper">
            <table id="kenshinDateExtractTable">
                <thead>
                    <tr>
                      <th></th>
                      <th>企業名</th>
                      <th v-for="(row, index) in kenshinList" :key="index">
                        {{row.label1}}
                      </th>
                      <th>合計</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(row, index) in data">
                        <tr :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{row.companyName}}</td>
                            <!-- 検査種類別 集計 -->
                            <td v-for="(column, colIndex) in kenshinList" :key="colIndex">
                              {{getData(row.kindSummary, column)}}
                            </td>
                            <td>{{row.total}}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="button-area">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>

    </div>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <judgmentDoctorSelectModal @select="setJudgmentName"></judgmentDoctorSelectModal>
    </b-modal>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import JudgmentDoctorSelectModal from "@/components/mock/philips/common/JudgmentDoctorSelectModal";

export default {
  name: "KenshinDateExtract",
  methods: {
    doSearch: function() {
      if (!this.inputCheck()) {
        return;
      }

      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalSpreadsheet.getSpreadsheetJudgmentDoctorReportPOST({
            body: {
              yearMonth: _this.searchCondition.yearMonth,
              doctorId: _this.searchCondition.doctorId
            }
          });
        },
        function(result){
          _this.data = result.obj
          _this.data.yearMonth = _this.replaceSlash(_this.searchCondition.yearMonth);
          _this.data.doctorName = _this.searchCondition.doctorName;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    inputCheck: function() {
      if (!this.searchCondition.yearMonth) {
        this.showErrorMessage('年月を入力してください。');
        return false
      }

      if (!this.searchCondition.doctorName) {
        this.showErrorMessage('判定医を選択してください。');
        return false
      }

      return true
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      navigator.clipboard.writeText(btable.innerText).then(() => {
          this.showMessage("クリップボードにコピーしました。");
        }).catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    setJudgmentName: function(jugdmentDoctorInfo) {
      this.searchCondition.doctorId = jugdmentDoctorInfo.belongsId;
      this.searchCondition.doctorName = jugdmentDoctorInfo.hospitalName;
    },
    back: function() {
      this.$router.go(-1);
    },
    getData: function(row, column) {
      var result = 0
      var item = row.find(item => {
        return item.inspectionType == column.value
      });

      if (item) {
        result = item.count;
      }
      return result;
    }
  },
  data() {
    var kenshinList = this.getChoiceList(choicesType.kenshinKind, true)

    return {
        role: role,
        searchCondition:{
          yearMonth: "",
          doctorId: 0
        },
        organizationModalActive: false,
        data: [],
        kenshinList: kenshinList
    };
  },
  filters: {},
  components: {
    judgmentDoctorSelectModal:JudgmentDoctorSelectModal,
  }
};
</script>
<style lang="scss" scoped>
input {
  width: 200px;
}
.table-wrapper {
    max-height: 1100px;
    overflow-y: scroll;
}
#kenshinDateExtractTable {
    font-size: 100% !important;
}
#kenshinDateExtractTable tr,
#kenshinDateExtractTable th,
#kenshinDateExtractTable td{
    border: black 1px solid;
    text-align: center;
    word-break : break-all;
}
#kenshinDateExtractTable td{
    width: 60px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/spreadSheet/KenshinDateExtract.vue